export default __webpack_public_path__ + "static/media/service_dashb.285e1cc1.svg";